import { render, staticRenderFns } from "./clAdvice.vue?vue&type=template&id=46f6c8c8&scoped=true&"
import script from "./clAdvice.vue?vue&type=script&lang=js&"
export * from "./clAdvice.vue?vue&type=script&lang=js&"
import style0 from "./clAdvice.vue?vue&type=style&index=0&id=46f6c8c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6c8c8",
  null
  
)

export default component.exports